import { useCallback, useEffect, useRef, useState } from "react"

import { resolveSharedFile } from "../api/shared-file.services"
import type { SharedFileResult } from "../types/shared-file.types"

type SharedFileState = { kind: "loading" } | SharedFileResult

/** The file a share link opens, resolved once per token. */
export const useSharedFile = (token: string) => {
  const [state, setState] = useState<SharedFileState>({ kind: "loading" })
  // Every resolve of a download-enabled link is recorded as a download, and
  // strict mode runs the effect twice; it also names the one answer to keep.
  const opening = useRef<string | null>(null)

  const load = useCallback(() => {
    opening.current = token
    setState({ kind: "loading" })
    void resolveSharedFile(token).then((result) => {
      if (opening.current === token) setState(result)
    })
  }, [token])

  useEffect(() => {
    if (opening.current === token) return
    load()
  }, [token, load])

  return { state, retry: load }
}
